"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrides = void 0;
const x = __importStar(require("@imtbl/x-client"));
const passport = __importStar(require("@imtbl/passport"));
const config = __importStar(require("@imtbl/config"));
const overrides = (baseConfig) => ({
    authenticationDomain: "https://auth.dev.immutable.com",
    magicPublishableApiKey: "pk_live_4058236363130CA9",
    magicProviderId: "C9odf7hU4EQ5EufcfgYfcBaT5V6LhocXyiPRhIjw2EY=",
    passportDomain: "https://passport.dev.immutable.com",
    imxPublicApiDomain: "https://api.dev.immutable.com",
    immutableXClient: new x.IMXClient({
        baseConfig,
        overrides: {
            immutableXConfig: x.createConfig({
                basePath: "https://api.dev.x.immutable.com",
                chainID: 15003,
                coreContractAddress: "0xd05323731807A35599BF9798a1DE15e89d6D6eF1",
                registrationContractAddress: "0x7EB840223a3b1E0e8D54bF8A6cd83df5AFfC88B2",
            }),
        },
    }),
    zkEvmRpcUrl: "https://rpc.dev.immutable.com",
    relayerUrl: "https://api.dev.immutable.com/relayer-mr",
    indexerMrBasePath: "https://api.dev.immutable.com",
    orderBookMrBasePath: "https://api.dev.immutable.com",
    passportMrBasePath: "https://api.dev.immutable.com",
});
exports.overrides = overrides;
// Test
() => {
    const baseConfig = new config.ImmutableConfiguration({
        environment: config.Environment.SANDBOX,
    });
    new passport.Passport({
        baseConfig,
        clientId: "imx-passport-client-id",
        redirectUri: "https://passport.dev.immutable.com/callback",
        overrides: (0, exports.overrides)(baseConfig),
    });
};
